import { render, staticRenderFns } from "./ExcuseView.vue?vue&type=template&id=038d79f6&scoped=true&"
import script from "./ExcuseView.vue?vue&type=script&lang=js&"
export * from "./ExcuseView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "038d79f6",
  null
  
)

export default component.exports